import { render, staticRenderFns } from "./StudentsModal.vue?vue&type=template&id=0b8b15f0&"
import script from "./StudentsModal.vue?vue&type=script&lang=js&"
export * from "./StudentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports